import { Radio } from "lucide-react";
import { useStore } from "zustand";
import { useCanMutateOpsTool } from "@/hooks/use-ops-access";
import { uiStore } from "@/lib/stores/ui-store";
import { SidebarCardButton } from "./sidebar-card-button";

/**
 * Admin-only entry point into Broadcast Controls, the panel where a broadcast is
 * started ("Go Live"). Always visible to broadcast-capable admins, whether or
 * not a broadcast is active. The live-broadcast controls (`BroadcastStatus`, the
 * rail "LIVE" button) only appear once a broadcast exists. Restores the entry
 * the in-sidebar ops panel used to provide (`canSeeBroadcast`) after the ops
 * tools moved to /operations.
 *
 * Shown on the `broadcast` tool's `moderate` grant (TECH-3239), exactly what
 * every procedure this panel drives requires, rather than on a role-name list.
 * Only one adapter seeds those role names, and such a list could drift from the
 * gate without anything failing.
 */
export function BroadcastControlsButton({
	collapsed = false,
}: {
	collapsed?: boolean;
}) {
	const canBroadcast = useCanMutateOpsTool("broadcast");
	const navigate = useStore(uiStore, (s) => s.navigate);

	if (!canBroadcast) return null;

	return (
		<SidebarCardButton
			collapsed={collapsed}
			icon={Radio}
			label="Broadcast Controls"
			onClick={() => navigate({ type: "broadcastControls" })}
		/>
	);
}
